import { useCallback } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'

import type { ReactElement } from 'react'
import type { MobileDeviceType } from '~/types/device-type'
import type { IAppEvent } from '~/types/event'
import type { IBuilderConfig, IGraphBuilderConfig } from '~/types/graph-builder'

import DynamicGraphBlock from '~/components/DynamicGraphBlock'
import MwMLoader from '~/components/MwMLoader'
import { COMMON_GRID_PROPS, dataNotAvailableText } from '~/const'
import { CA_PAGES, CA_SECTIONS } from '~/types/graph-builder'
import { getGraphLayoutPosition } from '~/utils/grid'

const ResponsiveGridLayout = WidthProvider(Responsive)

interface Props {
  appKey: string
  chartConfigs: IBuilderConfig[]
  deviceType: MobileDeviceType
  eventsData: IAppEvent[]
  isEventsLoading: boolean
  kpiField: string
}

const InstallsOverTimeBlock = ({
  appKey,
  chartConfigs,
  deviceType,
  eventsData,
  isEventsLoading,
  kpiField,
}: Props): ReactElement => {
  const graphOptions = useCallback(
    (config: IGraphBuilderConfig) => ({
      appKey,
      config,
      deviceType,
      eventsData,
      isLoading: isEventsLoading,
      kpiField,
    }),
    [appKey, deviceType, eventsData, isEventsLoading, kpiField]
  )

  if (isEventsLoading) {
    return <MwMLoader category="item" />
  }

  return (
    <>
      {chartConfigs.length > 0 ? (
        <ResponsiveGridLayout {...COMMON_GRID_PROPS} compactType={null} isDraggable={false} isResizable={false}>
          {chartConfigs
            .filter(({ section }) => section === CA_SECTIONS[CA_PAGES.APP_SUMMARY].INSTALLS_OVER_TIME)
            .map((config, idx) => (
              <div data-grid={getGraphLayoutPosition(`section-1-${idx}`, idx)} key={idx}>
                <DynamicGraphBlock
                  isDraggable={false}
                  withDefaultInstallationCountry={false}
                  {...graphOptions(config as IGraphBuilderConfig)}
                />
              </div>
            ))}
        </ResponsiveGridLayout>
      ) : (
        <div>{dataNotAvailableText}</div>
      )}
    </>
  )
}

export default InstallsOverTimeBlock
